import { RoundedCloseButton } from "../../Buttons/RoundedCloseButton/Index";
import { ButtonOnlyTitle } from "../../Buttons/ButtonOnlyTitle/Index";
import { useFilter } from "../../../hooks/useFilter";
import { Modal } from "../Default/Index";
import { useEditOnboarding } from "../../../hooks/useEditOnboarding";

export const InventoryTaskStop = () => {
    const { setModalInventoryTaskStop, modalInventoryTaskStop } = useFilter();
    const { setOptionForm } = useEditOnboarding();


    return (<>
        <div style={{ zIndex: 910 }}>
            <Modal
                visible={modalInventoryTaskStop}
                contentStyle={{
                    padding: "60px",
                    width: "433px",
                    height: "auto",
                    borderRadius: 25,
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    gap: 30
                }}
            >
                <header className="success__modal-header">
                    <RoundedCloseButton onClick={() => setModalInventoryTaskStop(false)} />
                </header>
                <h2 className="dateTitle">Realizar inventário</h2>
                <span>Esta ação impossibilitara a realização de tarefas até ser finalizada pelo capataz.</span>


                <footer className="buttons-container">
                    <ButtonOnlyTitle
                        title="Voltar"
                        theme="light"
                        onClick={() => {
                            setOptionForm(undefined)
                            setModalInventoryTaskStop(false)
                        }}
                    />
                    <ButtonOnlyTitle
                        title="Avançar"
                        theme="info"
                        onClick={() => {
                            setModalInventoryTaskStop(false)
                        }}
                    />
                </footer>
            </Modal>
        </div>
    </>)
}
